/* eslint-disable spire/export-styles */
import { MainNavigationStyles, MappedLink } from "@WhiteCap/Overrides/Widgets/Header/MainNavigation";
import GridItem, { GridWidths } from "@insite/mobius/GridItem";
import Link from "@insite/mobius/Link";
import CategorySectionComponent from "@WhiteCap/Components/CategorySectionComponent";
import * as React from "react";

interface OwnProps {
    link: MappedLink;
    styles: MainNavigationStyles;
    onHandleClose: Function;
}
const HeaderMenuLinkManager: React.FC<OwnProps> = ({ link, styles, onHandleClose }): any => {
    if (link.title === "CATEGORIES" && link.children && link.children?.length > 0) {
        return <CategorySectionComponent link={link} onHandleClose={onHandleClose} />;
    }
    return link.children!.map((child: MappedLink, index: number) => (
        <GridItem
            className="mega-menu-grid-item"
            width={(12 / link.numberOfColumns!) as GridWidths}
            key={`default-mega-menu-grid-item_${index}`}
            {...styles.megaMenuGridItem}
            as="li"
        >
            <Link className="mega-menu-heading-link" href={child.url}>
                {child.title}
            </Link>
            {child.children && (
                <ul data-test-selector={`linksFor_${child.title}`}>
                    {child.children.map((grandChild: MappedLink, index: number) => (
                        <li key={`default-mega-menu-link_${index}`}>
                            <Link
                                className="mega-menu-link"
                                {...styles.megaMenuLink}
                                href={grandChild.url}
                                data-test-selector={grandChild.title}
                            >
                                {grandChild.title}
                            </Link>
                        </li>
                    ))}
                </ul>
            )}
        </GridItem>
    ));
};

export default HeaderMenuLinkManager;
